import * as React from 'react';
import useLabelTranslation from 'src/hooks/useLabelTranslation';
import {useDispatch} from 'react-redux';

import * as reduxApi from 'src/utils/redux-api-v2';

import RichTextEditor from 'src/components/lib/rich-text-editor';

import {renderAsHTML} from 'src/components/crm/lib/common';
import {convertHTMLToDraftJS} from 'src/utils/crm-new/common';

import {Input} from '@spaced-out/ui-design-system/lib/components/Input';
import {Rating} from '@spaced-out/ui-design-system/lib/components/Rating';
import {SimpleDropdown} from '@spaced-out/ui-design-system/lib/components/Dropdown';
import {
  type FileObject,
  FileUpload,
} from '@spaced-out/ui-design-system/lib/components/FileUpload';
import {
  Toast,
  TOAST_SEMANTIC,
  ToastTitle,
  toastApi,
} from '@spaced-out/ui-design-system/lib/components/Toast';

import {
  SubTitleMedium,
  BodySmall,
  SubTitleSmall,
  FormLabelSmall,
} from '@spaced-out/ui-design-system/lib/components/Text';
import {Card} from '@spaced-out/ui-design-system/lib/components/Card';

import css from './evaluation-subjective-questions-edit.css';


const EvaluationSubjectiveQuestionsEdit = ({
  // @ts-expect-error - TS7031 - Binding element 'subjectiveSections' implicitly has an 'any' type.
  subjectiveSections,
  // @ts-expect-error - TS7031 - Binding element 'answers' implicitly has an 'any' type.
  answers,
  // @ts-expect-error - TS7031 - Binding element 'onChange' implicitly has an 'any' type.
  onChange,
  // @ts-expect-error - TS7031 - Binding element 'token' implicitly has an 'any' type.
  token,
  // @ts-expect-error - TS7031 - Binding element 'tokenId' implicitly has an 'any' type.
  tokenId,
  errorQuestionIds = [],
  // @ts-expect-error - TS7031 - Binding element 'setErrorQuestionIds' implicitly has an 'any' type.
  setErrorQuestionIds,
  // @ts-expect-error - TS7031 - Binding element 'noShow' implicitly has an 'any' type.
  noShow,
}) => {
  const {t} = useLabelTranslation();

  const dispatch = useDispatch();
  const [attachingFile, setAttachingFile] = React.useState(false);
  const [fileKeys, setFileKeys] = React.useState([]);
  const [files, setFiles] = React.useState([]);
  if (Array.isArray(subjectiveSections) && subjectiveSections.length === 0) {
    return null;
  }
  const handleParamScaleChange = (
    question: any,
    newRating: number,
    idx: any,
  ) => {
    let ans = answers?.[question.id]?.split(',') || [];

    if (ans.length < question.options.length) {
      ans = [...ans, ...Array(question.options.length - ans.length).fill(0)];
    }
    ans[idx] = newRating;

    onChange(question.id, ans.join(','));
  };

  const handleAttachFile = async (question: any, files: Array<FileObject>) => {
    try {
      if (files.length === 0) {
        return;
      }
      setAttachingFile(true);
      toastApi.show(
        <Toast semantic={TOAST_SEMANTIC.information}>
          <ToastTitle>{`${t(
            'File_Attachment_initiated',
            'File Attachment initiated',
          )}!`}</ToastTitle>
        </Toast>,
      );

      const formData = new FormData();
      formData.append('file', files[0].file);
      dispatch(
        reduxApi.post(
          `api/upload-attachment/v1`,
          formData,
          {},
          {apiPath: '/trmapi/'},
        ),
      ).then((response) => {
        onChange(question.id, response.filekey);
        toastApi.show(
          <Toast semantic={TOAST_SEMANTIC.success}>
            <ToastTitle>{`${t(
              'File_Attachment_successful',
              'File Attachment successful',
            )}!`}</ToastTitle>
          </Toast>,
        );
      });
    } catch (e: any) {
      toastApi.show(
        <Toast semantic={TOAST_SEMANTIC.danger}>
          <ToastTitle>{`${t(
            'File_Attachment_failed',
            'File Attachment failed',
          )}!`}</ToastTitle>
        </Toast>,
      );
    } finally {
      setAttachingFile(false);
    }
  };

  return (
    <>
      {subjectiveSections?.map((section: any, index: any) => (
        <div className={css.column}>
          <SubTitleMedium>{section.section.title || ''}</SubTitleMedium>
          <SubTitleSmall color="secondary">
            {section.section.description || ''}
          </SubTitleSmall>
          {section.section.questions?.map((question: any, qestIndex: any) =>
            question.fieldType === 'TEXT' || question.fieldType === 'NUMBER' ? (
              <Input
                label={`${t('Q', 'Q')}${qestIndex + 1}. ${
                  question.query || ''
                }`}
                required={question.required}
                placeholder=""
                size="medium"
                value={String(answers?.[question.id] || '')}
                type={question.fieldType === 'TEXT' ? 'text' : 'number'}
                onChange={(e) => {
                  onChange(
                    question.id,
                    question.fieldType === 'TEXT'
                      ? e.target.value
                      : Number(e.target.value),
                  );
                  setErrorQuestionIds(
                    errorQuestionIds.filter((id) => id !== question.id),
                  );
                }}
                // @ts-expect-error - TS2345 - Argument of type 'any' is not assignable to parameter of type 'never'.
                error={errorQuestionIds.includes(question.id)}
                errorText={t(
                  'This_field_is_required',
                  'This field is required',
                )}
                disabled={noShow}
              />
            ) : question.fieldType === 'MULTI_SELECT' ||
              question.fieldType === 'SINGLE_SELECT' ? (
              <SimpleDropdown
                label={`${t('Q', 'Q')}${qestIndex + 1}. ${
                  question.query || ''
                }`}
                required={question.required}
                selectedKeys={(answers?.[question.id] || '').split(',')}
                options={
                  question.options?.map((option: any) => ({
                    key: option,
                    label: option || '',
                    value: option,
                  })) || []
                }
                placeholder={`${t(
                  'Select_the_option_for',
                  'Select the option for',
                )} ${question.query || ''}`}
                // @ts-expect-error - TS2769 - No overload matches this call.
                isMulti={question.fieldType === 'MULTI_SELECT'}
                onChange={(option) => {
                  if (question.fieldType === 'SINGLE_SELECT') {
                    onChange(question.id, option.key);
                    setErrorQuestionIds(
                      errorQuestionIds.filter((id) => id !== question.id),
                    );
                  } else {
                    const currentAnswerArray = (
                      answers?.[question.id] || ''
                    ).split(',');
                    if (
                      // @ts-expect-error - TS7006 - Parameter 'answer' implicitly has an 'any' type. | TS2339 - Property 'key' does not exist on type 'ChangeEvent<HTMLInputElement> | MenuOption'.
                      currentAnswerArray.some((answer) => answer === option.key)
                    ) {
                      const updatedAnswer = currentAnswerArray
                        // @ts-expect-error - TS7006 - Parameter 'answer' implicitly has an 'any' type. | TS2339 - Property 'key' does not exist on type 'ChangeEvent<HTMLInputElement> | MenuOption'.
                        .filter((answer) => answer !== option.key)
                        .join(',');
                      onChange(question.id, updatedAnswer);
                      setErrorQuestionIds(
                        errorQuestionIds.filter((id) => id !== question.id),
                      );
                    } else {
                      const updatedAnswer = [
                        ...currentAnswerArray,
                        option.key,
                      ].join(',');
                      onChange(question.id, updatedAnswer);
                      setErrorQuestionIds(
                        errorQuestionIds.filter((id) => id !== question.id),
                      );
                    }
                  }
                }}
                // @ts-expect-error - TS2345 - Argument of type 'any' is not assignable to parameter of type 'never'.
                error={errorQuestionIds.includes(question.id)}
                errorText={t(
                  'This_field_is_required',
                  'This field is required',
                )}
                disabled={noShow}
              />
            ) : question.fieldType === 'TEXT_AREA' ? (
              <RichTextEditor
                required={question.required}
                label={`${t('Q', 'Q')}${qestIndex + 1}. ${
                  question.query || ''
                }`}
                placeholder=""
                // height={'300px'}
                onChange={(value) => {
                  onChange(question.id, value);
                  setErrorQuestionIds(
                    errorQuestionIds.filter((id) => id !== question.id),
                  );
                }}
                value={convertHTMLToDraftJS(answers?.[question.id] || '')}
                showActionButton={false}
                isDataLoading={false}
                // @ts-expect-error - TS2322 - Type '{ required: any; label: string; placeholder: string; height: string; onChange: (value: string | undefined) => void; value: string; showActionButton: false; isDataLoading: false; error: boolean; errorText: string; }' is not assignable to type 'IntrinsicAttributes & RichTextEditorProps'. | TS2345 - Argument of type 'any' is not assignable to parameter of type 'never'.
                error={errorQuestionIds.includes(question.id)}
                errorText={t(
                  'This_field_is_required',
                  'This field is required',
                )}
                disabled={noShow}
              />
            ) : question.fieldType === 'SINGLE_ATTACHMENT' ? (
              <FileUpload
                label={`${t('Q', 'Q')}${qestIndex + 1}. ${
                  question.query || ''
                }`}
                required={question.required}
                maxFiles={1}
                instruction={t(
                  'Drag_and_drop_or_click_to_upload_a_file',
                  'Drag and drop or click to upload a file',
                )}
                accept={{
                  ['*']: ['*'],
                }}
                onValidFilesDrop={(files) => {
                  setErrorQuestionIds(
                    errorQuestionIds.filter((id) => id !== question.id),
                  );
                  handleAttachFile(question, files);
                }}
                onFileClear={() => {
                  onChange(question.id, '');
                  setErrorQuestionIds(
                    errorQuestionIds.filter((id) => id !== question.id),
                  );
                }}
                disabled={noShow}
              />
            ) : question.fieldType === 'RATING' ? (
              <div className={css.column}>
                <FormLabelSmall color="secondary">{`${t('Q', 'Q')}${
                  qestIndex + 1
                }. ${question.query || ''}`}</FormLabelSmall>
                <div className={css.starQuestionContainerStars}>
                  <Rating
                    hideLabel
                    quiet
                    rating={Number(answers?.[question.id] || '0')}
                    onChange={(newRating) => {
                      onChange(question.id, newRating);
                      setErrorQuestionIds(
                        errorQuestionIds.filter((id) => id !== question.id),
                      );
                    }}
                    readOnly={noShow}
                  />
                </div>
              </div>
            ) : question.fieldType === 'PARAMETERIZED_RATING' ? (
              <div className={css.column}>
                <FormLabelSmall color="secondary">{`${t('Q', 'Q')}${
                  qestIndex + 1
                }. ${question.query || ''}`}</FormLabelSmall>
                <Card classNames={{wrapper: css.card}}>
                  {/* @ts-expect-error - TS7006 - Parameter 'parameter' implicitly has an 'any' type. | TS7006 - Parameter 'parameterIdx' implicitly has an 'any' type. */}
                  {question.options.map((parameter, parameterIdx) => {
                    const answerss =
                      answers?.[question.id]
                        ?.split(',')
                        .map((answer: any) => String(answer)) || [];

                    return (
                      <div className={css.parameterContainer}>
                        <FormLabelSmall color="secondary">
                          {parameter || ''}
                        </FormLabelSmall>
                        <Rating
                          hideLabel
                          quiet
                          rating={Number(answerss[parameterIdx] || 0)}
                          onChange={(newRating) => {
                            handleParamScaleChange(
                              question,
                              newRating,
                              parameterIdx,
                            );
                            setErrorQuestionIds(
                              errorQuestionIds.filter(
                                (id) => id !== question.id,
                              ),
                            );
                          }}
                          readOnly={noShow}
                        />
                      </div>
                    );

                    // <div>
                    //   <FormLabelSmall color="secondary">
                    //     {parameter}
                    //   </FormLabelSmall>
                    //   <div className={css.starQuestionContainerStars}>
                    //     <Rating
                    //       hideLabel
                    //       quiet
                    //       rating={Number(answerss[parameterIdx] || 0)}
                    //       onChange={(newRating) => {
                    //         handleParamScaleChange(
                    //           question,
                    //           newRating,
                    //           parameterIdx,
                    //         );
                    //         setErrorQuestionIds(
                    //           errorQuestionIds.filter(
                    //             (id) => id !== question.id,
                    //           ),
                    //         );
                    //       }}
                    //     />
                    //   </div>
                    // </div>
                  })}
                </Card>
              </div>
            ) : null,
          )}
        </div>
      ))}
    </>
  );
};

export default EvaluationSubjectiveQuestionsEdit;
